import React, {useEffect} from 'react';
import Modal from 'react-modal';
import './styles.scss';
import OrdersInfoTable from './table/table';
import {Button, Dimmer, Loader} from 'semantic-ui-react';
import {useDispatch, useSelector} from 'react-redux';
import {Actions} from '../../../../common/actions';

const {fetchGetOrdersByDate, cleanOrdersBYDate} = Actions;

export const stylesModal = {
  'overlay': {
    'background': 'rgba(0, 0, 0, 0.6)',
    'zIndex': 50,
  },
  'content': {
    'top': '50%',
    'left': '50%',
    'right': 'auto',
    'bottom': 'auto',
    'marginRight': '-50%',
    'transform': 'translate(-50%, -50%)',
  },
};

const OrderModal = ({openOrders, ordersInput, setOpenOrders, setFilters}) => {
  const dispatch = useDispatch();
  const {ordersByDate, 'loadingOrders': loading} = useSelector((state) => state.priorizationDates);

  useEffect(() => {
    ordersInput.value && dispatch(fetchGetOrdersByDate(ordersInput.value));
  }, [ordersInput]);

  useEffect(() => {
    return () => cleanOrdersBYDate();
  }, []);
  return (
    <>
      <Modal isOpen={openOrders} style={stylesModal}>
        <div className='priorization-modal-container'>
          <h2>
            {ordersInput.name}
          </h2>
          <div className='ml'>
            <OrdersInfoTable
              ordersByDate={ordersByDate}
              setFilters={setFilters}
              code={ordersInput.value}
              setOpenOrders={setOpenOrders}
            />
          </div>
          <div className='w-100 mt priorization-modal-order-cancel'>
            <Button
              type="button"
              basic
              className="toyota-secondary"
              onClick={() => setOpenOrders(false)}
            >
                  Cancelar
            </Button>
          </div>
        </div>
        {loading && (
          <Dimmer active inverted>
            <Loader inverted>Loading</Loader>
          </Dimmer>
        )}
      </Modal>
    </>
  );
};

export default OrderModal;
